import { idX } from "@insightfulscience/shared-utils/fn";
import type { IStorage } from "@interfaces";
import { ItemStorageFactory } from "./itemStorage";

export const refreshToken = ({ storage }: { storage: IStorage }) =>
	ItemStorageFactory<string>(storage, "rtoken", { expires: 365 }, idX, idX);
